module.exports = __webpack_public_path__ + "static/media/hall-P1.c071cf54.svg";